const DATA_SOURCE_LABELS: Record<string, string> = {
  equip_scout: "Equip Scout",
  external_import: "External",
  city: "City",
  web_research: "Web research",
  notion: "Notion",
};

export function getDataSourceLabel(source: string | null | undefined): string {
  if (!source) return "—";
  return DATA_SOURCE_LABELS[source] ?? source.replace(/_/g, " ");
}

const DATA_SOURCE_BADGE_STYLES: Record<string, string> = {
  equip_scout: "bg-blue-50 text-blue-700 border-blue-200",
  external_import: "bg-violet-50 text-violet-700 border-violet-200",
  city: "bg-emerald-50 text-emerald-700 border-emerald-200",
  web_research: "bg-sky-50 text-sky-700 border-sky-200",
  notion: "bg-amber-50 text-amber-700 border-amber-200",
};

export function getDataSourceBadgeClass(source: string | null | undefined): string {
  if (!source) return "bg-muted text-muted-foreground border-muted";
  return (
    DATA_SOURCE_BADGE_STYLES[source] ??
    "bg-muted text-foreground border-border"
  );
}
